<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zogBUo/tc-custom/9781504004237.jpg?1697127900652" alt="This image is the cover for the book Spirit Window"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spirit Window
      </h1>
      <p class="bookDescription body article font2">
        <b>On the edge of a Florida marsh, a young girl discovers the power of nature</b><br/><br/> After hours on the highway, Miranda is beginning to doubt that there is anything beautiful in Florida. But when her dad turns onto the bridge to Turtle Island and she sees the ocean for the very first time, she realizes she couldn’t have been more wrong.<br/>  <br/> Miranda has come here with her dad to meet her grandmother, whose cheerful energy conceals failing health. Miranda has been dreading this family vacation, but what she finds on Turtle Island will change her life forever.<br/>  <br/> Her grandmother is the self-appointed guardian of the local marsh, a swampy wonderland whose very existence is in jeopardy. A passionate photographer, Miranda plans only to document the landscape. But when a mysterious young boy named Adam draws her into the fight for the marsh’s future, she learns that saving the environment can be a matter of life or death.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joyce  Sweeney
      </h2>
      
      <p class="authorDescription body article">Joyce Sweeney is the author of fourteen books for young adults. Her novel&#160;<I>Center Line</I>&#160;won the first-annual Delacorte Press Prize for a First Young Adult Novel. Many of Sweeney&rsquo;s works have appeared on the American Library Association&rsquo;s Best Books for Young Adults list. Her novel&#160;<I>Shadow</I>&#160;won the Nevada Young Readers&rsquo; Award in 1997, and&#160;<I>Players</I>&#160;was chosen by <I>Booklist </I>as a Top 10 Sports Book for Youth and by <I>Working Mother</I> magazine as a Top Ten for Tweens.&#160;<I>Headlock</I>&#160;won a silver medal in the 2006 Florida Book Awards and was chosen by the American Library Association as a Quick Pick for Reluctant Young Adult Readers. Sweeney also writes short stories and poetry and conducts ongoing workshops in creative writing, which have so far produced forty published authors. She lives in Coral Springs, Florida, with her husband, Jay, and cat, Nitro.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4acbf18f